import React from 'react';
import { FormattedMessage } from 'react-intl';

import AlertBox from 'components/ui/AlertBox';

const MealChangeWarning = () => (
  <AlertBox variant={AlertBox.variants.WARNING}>
    <FormattedMessage id="meals.changeWarning" />
    <ul>
      <li>
        <FormattedMessage id="meals.24hourMeals" />
      </li>
      <li>
        <FormattedMessage id="meals.48hourMeals" />
      </li>
    </ul>
  </AlertBox>
);

export default MealChangeWarning;
